var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "alert alert-success" }, [
      _c("h3", [_vm._v(_vm._s(_vm.header))]),
      _vm._v(" "),
      _c("div", { domProps: { innerHTML: _vm._s(_vm.text) } }),
    ]),
    _vm._v(" "),
    _c("div", [
      _c(
        "a",
        { staticClass: "btn btn-primary mx-auto", on: { click: _vm.reload } },
        [_vm._v(_vm._s(_vm.$t("btn_label_close")))]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }